import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext } from 'commons-ui';
import { IConversionConfig, ISegmentConfigData } from '../../utils/type';
import useService from '../../utils/useService';
import { getFormDefaults } from '../../utils/formConfig';
import { dehydrateFormData } from '../../utils/formDataParser';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history: any = useHistory();
	const { requestCreateConfig } = useService();
	const createOffer = (conversionConfig: IConversionConfig) => {
		setShowLoader(true);
		requestCreateConfig(app.appName, { ...conversionConfig }).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || 'Error occured while creating the CTD Config', { type: 'error' });
					setShowLoader(false);
				} else {
					showAlert('Config Created');
					history.goBack();
				}
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: ISegmentConfigData) => {
		createOffer(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	const segmentLabelList: { id: string; label: string }[] = history?.location?.state?.segmentList;
	const expLabelList: { id: string; label: string }[] = history?.location?.state?.expList;
	const bucketList: { [key: string]: string } = history?.location?.state?.bucketList;

	return {
		data: getFormDefaults(segmentLabelList, expLabelList, bucketList),
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useCreate;
